<template>
  <div style="margin-top: 5rem">
    <v-slide-y-reverse-transition>
      <v-card v-if="getPriceTotal() > 0" tile outlined class="elevation-12" style="position: fixed; bottom: 0; right:0; left:0">
        <v-card-actions>
          <v-row align="center" justify="center" class="ma-0 ml-2">
            <v-col cols="8" class="text-left pa-0" style="font-size: 20px;">
              <span>Preț total</span><br/>
              <im-price :font-size="20" :price="getPriceTotal()" :currency="getPriceCurrency()"/>
            </v-col>
            <v-col cols="4" class="text-right pa-0">
              <v-btn color="primary" class="text-right" style="height: 60px" depressed block @click="$emit('book')">
                Rezervă
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>

  import IMPrice from "../utils/IMPrice";

  export default {

    components: {
      'im-price': IMPrice
    },

    props: {
      availability: {
        type: Object,
        default: () => null
      }
    },

    data: () => ({ }),

    methods: {
      getPriceTotal() {
        let total_price = 0;
        this.availability.rooms.forEach(room => {
          room.prices.forEach(rate => {
            if (rate.quantity > 0) {
              total_price += rate.price * rate.quantity;
            }
          });
        });

        return total_price;
      },

      getPriceCurrency() {
        return this.availability.currency;
      }
    }

  }
</script>
